import { ReactComponent as ZocksIcon } from '../../assets/ZocksIcon.svg'
import classNames from 'classnames'
import { IntegrationRequirementMessage } from '../../common/IntegrationRequirementMessage'
import { InteractiveTooltip } from '../../components/InteractiveTooltip/InteractiveTooltip'
import { ZoomOBFWarningTooltip } from '../../components/ZoomOBFWarning/ZoomOBFWarningTooltip'
import { CantJoinIntegrationIcon } from './CantJoinIntegrationIcon'
import { useCantJoinTooltip } from './useCantJoinTooltip'

const ASSISTANT_STATUS_TITLE_MAP = {
  notStarted: 'Assistant Not Started',
  inWaitingRoom: 'Assistant In Waiting Room',
  analyzing: 'Assistant Analyzing',
  analyzed: 'Assistant Analyzed',
  cantJoin: "Assistant can't join",
}

export interface AssistantStatusBadgeProps {
  assistantStatus: 'notStarted' | 'inWaitingRoom' | 'analyzing' | 'analyzed' | 'cantJoin'
  source?: string
}

export const AssistantStatusBadge: React.FC<AssistantStatusBadgeProps> = ({ assistantStatus, source }) => {
  const { serviceId, tooltipType } = useCantJoinTooltip(source)
  const isCantJoin = assistantStatus === 'cantJoin'

  const badgeDiv = (
    <div
      className={classNames('d-flex align-content-center align-items-center p-1 gap-2 zocks-border-0.25', {
        'zocks-border-primary-light': !isCantJoin && assistantStatus !== 'analyzed',
        'zocks-border-gray-500': isCantJoin,
        'zocks-border-gray-200 zocks-bg-color-gray-200': assistantStatus === 'analyzed',
        'zocks-bg-color-primary-light': assistantStatus === 'analyzing',
      })}
    >
      {isCantJoin ? <CantJoinIntegrationIcon source={source} /> : <ZocksIcon width={16} height={16} />}
      <span className='button-small'>{ASSISTANT_STATUS_TITLE_MAP[assistantStatus]}</span>
    </div>
  )

  if (!isCantJoin || tooltipType === 'none') {
    return badgeDiv
  }

  if (tooltipType === 'zoom-obf') {
    return <ZoomOBFWarningTooltip>{badgeDiv}</ZoomOBFWarningTooltip>
  }

  return (
    <InteractiveTooltip content={<IntegrationRequirementMessage serviceId={serviceId!} isTooltip />} offset={[0, 8]}>
      {badgeDiv}
    </InteractiveTooltip>
  )
}
